<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div *ngIf="this.connected">
        <button mat-icon-button color="primary" class="back-button" routerLink="/menu">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <div *ngIf="!this.connected">
        <button mat-icon-button color="primary" class="back-button" routerLink="/">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <mat-card-title>{{ 'ABOUT.HEADER' | translate }}</mat-card-title>
        </mat-card-title-group>
        <mat-card-content> 
            <div class="home-card" id="content">
                <div class="home-nav">
                <mat-nav-list>
                    <button mat-stroked-button class="mat-item-button" routerLink="licence" color="primary">
                        <mat-icon>verified_user</mat-icon>
                        {{ 'ABOUT.LICENCE' | translate }}</button>
                    <button mat-stroked-button class="mat-item-button" (click)="openRelease()" color="primary">
                        <mat-icon>assignment</mat-icon>
                        {{ 'ABOUT.RELEASE' | translate }}
                    </button> 
                </mat-nav-list>
                <div *ngIf="this.open">
                    <mat-card class="release">
                        <ng-container *ngIf="!loaded">
                            <div class="loading">
                                <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="loaded">
                            <div class="releaseNotes">
                                <h3 class="header_big">{{ 'ABOUT.FRONTEND' | translate }} Version: {{this.frontendVersion}}</h3>
                                <div class="notes">
                                    <div class="feature" *ngIf="frontendReleaseNotes.features.length > 0">
                                        <p class="header">{{ "RELEASENOTES.FEATURE" | translate }}</p>
                                            <mat-list class="list">
                                                <mat-list-item *ngFor="let item of frontendReleaseNotes.features">
                                                    <div matLine>&bull; {{ item }}</div>
                                                </mat-list-item>
                                            </mat-list>
                                    </div>
                                    <div class="improvement" *ngIf="frontendReleaseNotes.improvements.length > 0">
                                        <p class="header">{{ "RELEASENOTES.IMPROVEMENT" | translate }}</p>
                                        <mat-list class="list">
                                            <mat-list-item *ngFor="let item of frontendReleaseNotes.improvements">
                                                <div matLine>&bull; {{ item }}</div>
                                            </mat-list-item>
                                        </mat-list>
                                    </div>
                                    <div class="bugfix" *ngIf="frontendReleaseNotes.bugfixes.length > 0">
                                        <p class="header">{{ "RELEASENOTES.BUGFIX" | translate }}</p>
                                        <mat-list class="list">
                                            <mat-list-item *ngFor="let item of frontendReleaseNotes.bugfixes">
                                                <div matLine>&bull; {{ item }}</div>
                                            </mat-list-item>
                                        </mat-list>
                                    </div>
                                </div>    
                            </div>
                            <mat-divider style="margin: 5px 0 5px 0"></mat-divider>
                            <div class="releaseNotes">
                                <h3 class="header_big">{{ 'ABOUT.BACKEND' | translate }} Version: {{this.backendVersion}}</h3>
                                <div class="notes">
                                    <div class="feature" *ngIf="backendReleaseNotes.features.length > 0">
                                        <p class="header">{{ "RELEASENOTES.FEATURE" | translate }}</p>
                                            <mat-list class="list">
                                                <mat-list-item *ngFor="let item of backendReleaseNotes.features">
                                                    <div matLine>&bull; {{ item }}</div>
                                                </mat-list-item>
                                            </mat-list>
                                    </div>
                                    <div class="improvement" *ngIf="backendReleaseNotes.improvements.length > 0">
                                        <p class="header">{{ "RELEASENOTES.IMPROVEMENT" | translate }}</p>
                                        <mat-list class="list">
                                            <mat-list-item *ngFor="let item of backendReleaseNotes.improvements">
                                                <div matLine>&bull; {{ item }}</div>
                                            </mat-list-item>
                                        </mat-list>
                                    </div>
                                    <div class="bugfix" *ngIf="backendReleaseNotes.bugfixes.length > 0">
                                        <p class="header">{{ "RELEASENOTES.BUGFIX" | translate }}</p>
                                        <mat-list class="list">
                                            <mat-list-item *ngFor="let item of backendReleaseNotes.bugfixes">
                                                <div matLine>&bull; {{ item }}</div>
                                            </mat-list-item>
                                        </mat-list>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </mat-card>
                </div>
                </div>
            </div>
        </mat-card-content>
        <mat-card-footer>
            <mat-divider></mat-divider>
            <div class="home-card" id="footer">
                <div class="versions">
                    <a class="frontend">Frontend-Version: {{this.frontendVersion}} </a>
                    <a>Backend-Version: {{this.backendVersion}}</a>
                </div>
            </div>
        </mat-card-footer>
    </div>
</mat-card>

